import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { useQuery } from "@tanstack/react-query";
import { getUserReports } from "@/services/report-service";
import logoIcon from "../../assets/logo-icon.svg";
import { useNavigate } from "react-router-dom";
import { Report, UserReportsRequest, UserReportsResponse } from "@/types/report";
import { useUser } from "@/hooks/useUser";

export function ReportsScreen() {
  const navigate = useNavigate();
  const {userInfo} = useUser();

  const userReportsRequest: UserReportsRequest = {
    clientId: 57844,
    userId: userInfo?.userId ?? null
  };

  const {
    data: userReports,
    isLoading,
  } = useQuery({
    queryKey: ["userReports", userReportsRequest],
    queryFn: () => getUserReports(userReportsRequest),
    enabled: !!userInfo?.userId,
  });
  const handleViewReport = (report: Report) => {
    navigate(`/report/${report.id}`, { state: { report } });
  };

  return (
    <>
      <h2 className="text-3xl font-bold mb-6 text-forest">Reports</h2>
      {isLoading ? (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-100">
          <div className="animate-pulse">
            <img
              src={logoIcon}
              alt="Logo"
              className="w-32 h-32 animate-grow-shrink"
            />
          </div>
        </div>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="text-forest">Name</TableHead>
              <TableHead className="text-forest">Type</TableHead>
              <TableHead className="text-forest">Action</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {userReports?.map((report: UserReportsResponse) => (
              <TableRow key={report.id}>
                <TableCell className="text-forest">{report.name}</TableCell>
                <TableCell className="text-forest">
                  {report.reportType}
                </TableCell>
                <TableCell>
                  <Button onClick={() => handleViewReport(report)}>View</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </>
  );
}